<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-button type="primary" @click="addMedicines" style="width: 96px">新增剂型</el-button>
                </div>
            </div>
            <div>
                <el-table :data="tableData"
                          :header-cell-style="{'padding-left': '10%'}"
                          :cell-style="{'padding-left': '10%'}">
                    <el-table-column prop="medicinesType" label="药品类型"></el-table-column>
                    <el-table-column prop="medicinesDosage" label="药品剂型"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="editMedicines(scope.row)">编辑</el-button>
                            <el-button type="text" class="delete-button" @click="deleteMedicines(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="新增剂型" :visible.sync="dialogAddVisible" width="520px">
            <el-form :model="medicinesAdd" :rules="addRules" ref="addMedicines" label-width="100px" size="small">
                <el-form-item label="药品类型"  prop="medicinesType">
                    <el-input v-model="medicinesAdd.medicinesType" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="药品剂型" prop="medicinesDosage">
                    <el-input v-model="medicinesAdd.medicinesDosage" style="width: 282px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogAddVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="编辑剂型" :visible.sync="dialogEditVisible" width="520px">
            <el-form :model="medicinesEdit" :rules="editRules" ref="editMedicines" label-width="100px" size="small">
                <el-form-item label="药品类型" prop="medicinesType">
                    <el-input v-model="medicinesEdit.medicinesType" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="药品剂型" prop="medicinesDosage">
                    <el-input v-model="medicinesEdit.medicinesDosage" style="width: 282px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogEditVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmEdit" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // 表格信息
                tableData: [
                    {
                        medicinesId: '1',
                        medicinesType: '中草药',
                        medicinesDosage: '饮片',
                    }
                ],
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 1,
                pages: 1,
                // 弹窗开关
                dialogAddVisible: false,
                dialogEditVisible: false,
                // 新增剂型弹窗数据
                medicinesAdd:{
                    medicinesType: '',
                    medicinesDosage: '',
                },
                addRules: {
                    medicinesType: [{required: true, message: '请输入药品类型', trigger: 'blur'}],
                    medicinesDosage: [{required: true, message: '请输入药品剂型', trigger: 'blur'}],
                },
                // 编辑剂型弹窗数据
                medicinesEdit:{
                    medicinesType: '',
                    medicinesDosage: '',
                },
                editRules: {
                    medicinesType: [{required: true, message: '请输入药品类型', trigger: 'blur'}],
                    medicinesDosage: [{required: true, message: '请输入药品剂型', trigger: 'blur'}],
                },
            }
        },
        methods: {
            // 获取剂型列表
            queryMedicines() {
                console.log("aaa")
            },
            // 表格换页
            handlePageChange(val) {
                this.pageNum = val;
                this.queryMedicines();
            },
            // 打开新增剂型弹窗
            addMedicines() {
                this.dialogAddVisible =true
                this.$nextTick(()=>{
                    this.$refs.addMedicines.resetFields();
                });
            },
            // 确定添加剂型
            confirmAdd() {
                console.log(this.medicinesAdd)
            },
            // 打开编辑剂型弹窗
            editMedicines(data) {
                this.dialogEditVisible = true
                console.log(data)
                this.medicinesEdit.medicinesType = data.medicinesType
                this.medicinesEdit.medicinesDosage = data.medicinesDosage
                this.$nextTick(()=>{
                    this.$refs.editMedicines.clearValidate();
                });
            },
            // 确认编辑剂型
            confirmEdit() {
                console.log(this.medicinesEdit)
            },
            // 删除剂型
            deleteMedicines(date) {
                this.$confirm('您确认要删除此剂型?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message.success('删除成功');
                    // this.axios.post('1000/10016/100023', params,{
                    //     headers:{
                    //         token: this.authorization
                    //     }
                    // }).then(res =>{
                    //     if(res.data.code === 10000) {
                    //         this.$message.success(res.data.message);
                    //         // 查询现有角色
                    //         this.queryRole()
                    //     } else {
                    //         this.$message.error(res.data.message);
                    //     }
                    // }).catch(error => {
                    //     this.$message.error(error);
                    // });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        },
        created() {
            this.queryMedicines()
        }
    }

</script>
<style>
    /*删除提示位置提高*/
    .el-message-box {
        margin-top: -300px;
    }
</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
</style>